import { CommonActions, useNavigation, useRoute } from "@react-navigation/native";
import ListItem from 'components/atoms/ListItem';
import VStack from "components/atoms/stack/VStack";
import ThemedBlock from "components/atoms/ThemedBlock";
import ThemedLayout, { createRefreshControl } from "components/atoms/ThemedLayout";
import ThemedList from "components/atoms/ThemedList";
import ThemedLoader from 'components/atoms/ThemedLoader';
import ThemedModal from "components/atoms/ThemedModal";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import MutationTransaction from "graphql/mutations/MutationTransaction";
import { useState } from "react";
import { StyleSheet } from "react-native";
import { useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import { ThemedValues } from "styles/themed";
import Button from "theme/Button";
import Text from "theme/Text";
import FetchCreditBundles from "utils/fetch/FetchCreditBundles";
import { openUrl } from "utils/helper-url";
import HelperPrice from "utils/helper/HelperPrice";
import useRouteParameters from "utils/hooks/use-route-parameters";
import useFetch from "utils/hooks/useFetch";
import useMutate from "utils/hooks/useMutate";
import i18n from "utils/i18n";
import _, { set } from "lodash";
import Translate from "utils/translate";
import { AppRoutes } from "navigations/app-routes";
import ModalBuy from "scenes/home/more/credits/bundles/modalBuy";
import HelperAlerts from 'utils/HelperAlerts';

const HomeMoreCreditsBundleScene = () => {

	const navigation = useNavigation();
	const route = useRoute();
	const _routeParameters = useRouteParameters( route );

	const fromBooking = (_routeParameters?.fromBooking === 'true' || _routeParameters?.fromBooking === true ) || false;
	
	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );
	const [ buyModalItem, setBuyModalItem ] = useState( null );

	const { data, loading } = useFetch( FetchCreditBundles.fetchAll, {
		variables: {
			timeslot_kind_guid: _routeParameters?.timeslot_kind_guid || null,
		}
	});

	const [ createTransaction, { loading: transactionLoading, error: transactionError, data: transactionData } ] = useMutate( MutationTransaction );

	const renderItem = ({ item, index }) => {

		const timeslotKind = _.find( _timeslotKinds, { guid: item?.timeslot_kind?.guid } )
		const timeslotKindTitle = Translate.field( timeslotKind, 'title' )

		const itemTitle = Translate.field( item, 'title' );
		const title = timeslotKindTitle + ' - ' + itemTitle;

		return (
			<ListItem
				title={ title }
				subtitle={ HelperPrice.format( item.price ) }
				accessoryRight={(
					<Button
						onPress={ onPressBuy.bind( this, item ) }>

						{ i18n.t( 'buttons.buy' ) }
					</Button>
				)}
			/>
		)
	}

	const onPressBuy = ( item ) => {
		setBuyModalItem( item );
	}

	const onPressConfirmBuy = ( amount ) => {
		if( transactionLoading ) {
			return;
		}

		createTransaction({
			variables: {
				credit_bundle_guid: buyModalItem.guid,
				amount: amount,
			}, 
			onSuccess: ( result ) => {
				// Close the modal
				setBuyModalItem( null );

				if( fromBooking ) {
					navigation.replace( AppRoutes.MORE_CREDITS_BUY_PAYMENT, {
						transaction: result.guid,
						fromBooking: true,
					});
				} else {
					navigation.dispatch( CommonActions.reset( {
						index: 1,
						routes: [
							{
								name: AppRoutes.MORE_CREDITS_BUY_PAYMENT,
								params: { transaction: result.guid }
							}
						]
					}));
				}

				// Open the payment URL!
				openUrl( result?.payment?.external_redirect_url, fromBooking ? '_blank' : '_self' )
			},
			onError: () => {
				HelperAlerts.alert(
					i18n.t( 'page.credits_buy.modal.title' ),
					i18n.t( 'page.credits_buy.payment.failed' ),
				);
			},
		})
	}
	
	return (
		<ThemedSafeAreaComponentTop top={false}>
			<ThemedLayout
				topNavigation={ true }
				showBackButton
				title={ i18n.t( 'titles.credits_buy' ) }
				scrollViewProps={{
					...createRefreshControl({
						// onRefresh: reloadMessages.bind( this )
					})
				}}>

				{ loading && (
					<ThemedLoader text={ i18n.t( 'basic.loading' ) } />
				)}
				
				{ !loading && (
					<VStack
						space={ ThemedValues.stackSpace }>

						<ThemedBlock shadow>
							<ThemedList
								style={ styles.listContainer }
								data={ data }
								renderItem={ renderItem.bind( this ) }
								scrollEnabled={ false }
							/>
						</ThemedBlock>
					</VStack>
				)}
			</ThemedLayout>

			{ buyModalItem !== null && (
				<ModalBuy
					item={ buyModalItem }
					loading={ transactionLoading }
					setVisible={ setBuyModalItem.bind( this, null )}
					onPressConfirmBuy={ onPressConfirmBuy }
				/>
			)}
		</ThemedSafeAreaComponentTop>
	);
}

const styles = StyleSheet.create({
	listContainer: {
		flex: 1
	}
})

export default HomeMoreCreditsBundleScene;
